import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useContext } from "react";
import { GTM_PROJECT_SAVE_PACKAGING } from "../graphql";
import { GTMProjectContext } from "../GTMProjectContext";
import PackagingBaseInfoView from "./PackagingBaseInfoView";
import DesignersView from "./packagingViews/DesignersView";
import SalesView from "./packagingViews/SalesView";
import StellaView from "./packagingViews/StellaView";

const GTMProjectPackagingDataView = ({ pkg, index, disabled }) => {
  const { originalGTMProject } = useContext(GTMProjectContext);
  const [save, saveRes] = useMutation(GTM_PROJECT_SAVE_PACKAGING, {
    onCompleted() {
      Alert("success", "Packaging deleted.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function deleteHandler() {
    if (window.confirm("Are you sure to delete this packaging?")) {
      save({
        variables: {
          gtmProjectId: originalGTMProject.id,
          packagingId: pkg.id,
          deleted: true,
        },
      });
    }
  }

  const basic = JSON.parse(pkg.basic);

  return (
    <div key={index}>
      <div className="flex justify-between items-start">
        <div>
          <div className="flex items-center justify-between">
            <div className="font-black text-xl">
              Packaging #{index + 1}. {basic.name}
            </div>
          </div>
          <div className="opacity-70">
            Please fill in the details about this package below. Make sure all
            information is accurate and complete.
          </div>
        </div>
        {!disabled && (
          <Button danger onClick={deleteHandler} loading={saveRes.loading}>
            Delete Packaging
          </Button>
        )}
      </div>

      <PackagingBaseInfoView packaging={pkg} disabled={disabled} />
      <DesignersView pkg={pkg} disabled={disabled} />
      <SalesView pkg={pkg} disabled={disabled} />
      <StellaView pkg={pkg} disabled={disabled} />
    </div>
  );
};

export default GTMProjectPackagingDataView;
